import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import { Button, Container } from '@mui/material';
import axios from 'axios';
import { baseURL } from '../base_url';
import { PuffLoader } from 'react-spinners';
import { MDBDataTable } from 'mdbreact';
import { read, utils, writeFile } from 'xlsx';
import { RiFileExcel2Fill } from "react-icons/ri";
import { Form, Col, Row } from 'react-bootstrap';
import Select from "react-select";
import moment from 'moment';

const FetchFleet = () => {
    const [movies, setMovies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fetchFleet, setFetchFleet] = useState([]);
    const fileInputRef = useRef(null);
     
    const loggedInUser = sessionStorage.getItem("tm_token");
    const foundUser = JSON.parse(loggedInUser);
    const [exportTableData, setExportTableData] = useState([]);
    const [companyOption, setCompanyOption] = useState(null);
    const [companyLabel, setCompanyLabel] = useState(null);
    const [companyItems, setCompanyItems] = useState([]);

    const handleCompanyChange = (selectedOption) => {
        setCompanyOption(selectedOption.value)
        setCompanyLabel(selectedOption.label)
    }

    const handleSubmitForm = () => {
        setLoading(true);
        axios.post(baseURL + "/get_contract", {
            'company':companyOption
        }).then((res) => {
            var j = 1;
            if(res.data.length > 0){
                let rowsData = [];
                let ExportTableData = [];
                const myDataSet = res.data;
                for (var index = 0; index < res.data.length; index++) {
                    let rowItem = {};
                    const val = myDataSet[index];
                    rowItem["id"] = j;
                    rowItem["contract"] = val._id;
                    rowItem["vin"] = val.vin;
                    rowItem["from"] = val.from;
                    rowItem['to'] = val.to;
                    rowItem['status'] = val.status;
                    rowItem['pack'] = val.pack;
                    if (val.last_api_response) {
                        rowItem['last_api_response'] = moment(new Date(val.last_api_response))
                            .tz("US/Eastern")
                            .format('MM/DD/YYYY hh:mm A');
                    } else {
                        rowItem['last_api_response'] = "No Data"; // Or set to null or any default value you prefer
                    }
                    // rowItem['last_api_response'] = moment(new Date(val.last_api_response)).tz("US/Eastern").format('MM/DD/YYYY hh:mm A');
                    rowItem['agreement_number'] = val.agreement_number;
                    rowItem['vin_status'] = val.vin_status
                    if(val.odometer_value)
                    {
                        rowItem['api_odometer'] = val.odometer_value+' '+val.odometer_unit
                    }
                    else{
                        rowItem['api_odometer'] = ''
                    }
                    
                    ExportTableData.push([j, val._id,val.vin, val.from, val.to, val.status, val.pack, companyLabel, rowItem['last_api_response'], rowItem['agreement_number'], rowItem['vin_status'] ,rowItem['api_odometer']])
                    rowsData.push(rowItem)
                    j++;
                }
                setExportTableData(ExportTableData)
                setFetchFleet(rowsData);
            }else{
                setFetchFleet([]);
            }
            setLoading(false);
        });
    }

    useEffect(() => {
        axios.get(baseURL + "/get_stellantis_company").then((res) => {
            if(res.data.length > 0)
            {
                const formattedData = res.data.map(item => ({
                    value: item.company_id,
                    label: item.name,
                }));
                setCompanyItems(formattedData);
            }
        })
    },[]);

    const data = {
        columns: [
            {
            label: 'S.No',
            field: 'id',
            },
            {
            label: 'Contract ID',
            field: 'contract',
            },
            {
            label: 'VIN',
            field: 'vin',
            },
            {
            label: 'From Date',
            field: 'from',
            },
            {
            label: 'To Date',
            field: 'to',
            },
            {
            label: 'Status',
            field: 'status',
            },
            {
            label: 'Pack',
            field: 'pack',
            },
            {
            label: 'API Response',
            field: 'last_api_response',
            },
            {
            label: 'Agreement Number',
            field: 'agreement_number',
            },
            {
            label: 'VIN Status',
            field: 'vin_status',
            },
            {
            label: 'API Odometer',
            field: 'api_odometer',
            },
        ],
        rows: fetchFleet
    };
    const handleExportTableData = () => {
        const headings = [['S.No','Contract ID','VIN Nimber','From Date','To Date','Status','Pack','Company','Last API Response', 'Agreement Number', 'VIN Status' ,'API Odometer']];
        const sampleVin = exportTableData;
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, sampleVin, { origin: 'A2', skipHeader: true });
        utils.book_append_sheet(wb, ws, 'Stellantis Fleet List');
        writeFile(wb, 'Stellantis Fleet List.xlsx');
    }
    return(
        <div className='body_class'>
            {loading ? (
                <div className="loader-overlay">
                    <div className="loader">
                    <PuffLoader color="#00308F" loading={true} size={200} />
                    </div>
                </div>
            ) : ("")}
            <div className='container-fluid'>
            <div className="">
                <h4>Stellantis Fleet Info</h4>
            </div>
            <div className="row mt-1">
                <div>
                    <Form>
                        <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                            <Form.Label column sm="2">
                                Company
                            </Form.Label>
                            <Col sm="5">
                                <Select placeholder="Select Company" 
                                options={companyItems} 
                                onChange={handleCompanyChange} 
                                value={companyItems.find(option => option.value === companyOption)}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                        <Form.Label column sm="2"></Form.Label>
                        <Col sm="5">
                        <Button variant="contained" onClick={handleSubmitForm}>Fetch</Button>
                        </Col>
                        </Form.Group>
                    </Form>
                </div>
                <div className="col-md-12">
                    <Button size="small" className="" style={{marginBottom:"-3.5rem"}} variant="contained" onClick={handleExportTableData}>
                        <RiFileExcel2Fill size={16}/>&nbsp;Export
                    </Button>
                    <MDBDataTable
                    bordered
                    data={data}
                    large={false}
                    displayEntries={false}
                    search="true"
                    noBottomColumns={true}
                    className="pagination-right-aligned"
                    searching={true}
                    />
                </div>
            </div>
            </div>
        </div>
      )
      
}

export default FetchFleet;